import { PageElementsFamily, createLocation } from "../../state/page";

import { effects } from "@quickpoint.me/shared";
import { useRecoilValue } from "recoil";

const useFx = ({ pageIndex, atomId, isInAuthor }: { pageIndex: number, atomId: number, isInAuthor: boolean }): string => {
    if (isInAuthor) return ""
    //console.log("useFx")
    const key = createLocation(pageIndex, atomId);
    const modifier = useRecoilValue(PageElementsFamily(key)).data.modifier;
    if (modifier?.["effect:"] && effects.has(modifier["effect:"])) {
        return modifier["effect:"]
    }

    return ""

}

export default useFx